import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=36b6e99d"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"
import style0 from "./MainComponent.vue?vue&type=style&index=0&id=36b6e99d&prod&lang=css"
import style1 from "./MainComponent.vue?vue&type=style&index=1&id=36b6e99d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports